import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = ({ openRequestModal }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 bg-white/70 backdrop-blur-md border-b border-gray-200/50 shadow-sm">
      <div className="max-w-6xl mx-auto px-6">
        {/* Desktop Layout */}
        <div className="hidden md:flex md:items-center md:justify-between h-16">
          {/* Logo */}
          <Link to="/" className="text-xl font-bold text-gray-900 hover:text-blue-600 transition-colors">
            DigiTables.ai
          </Link>
          
          {/* Navigation */}
          <nav className="flex items-center h-full">
            <Link 
              to="/about" 
              className={`px-4 h-full flex items-center text-sm font-semibold tracking-wide transition-all duration-200 ${
                isActive('/about')
                  ? 'text-gray-900 bg-gray-100'
                  : 'text-gray-800 hover:text-gray-900 hover:bg-gray-100'
              }`}
            >
              About
            </Link>
            <Link 
              to="/solution" 
              className={`px-4 h-full flex items-center text-sm font-semibold tracking-wide transition-all duration-200 ${
                isActive('/solution')
                  ? 'text-gray-900 bg-gray-100'
                  : 'text-gray-800 hover:text-gray-900 hover:bg-gray-100'
              }`}
            >
              Solutions
            </Link>
          </nav>
          
          {/* CTA Buttons */}
          <div className="flex items-center gap-3">
            <Link 
              to="/login"
              className="text-purple-600 hover:text-purple-700 px-4 py-2 text-sm font-medium transition-all duration-200 border border-purple-200 rounded-lg hover:bg-purple-50"
            >
              Alpha Login
            </Link>
            <button 
              onClick={openRequestModal}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 shadow-sm hover:shadow-md"
            >
              Get Started
            </button>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden flex items-center justify-between h-16">
          <Link to="/" className="text-xl font-bold text-gray-900">
            DigiTables.ai
          </Link>
          
          <button
            onClick={toggleMenu}
            className="p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-all duration-200"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-200/50 bg-white/95 backdrop-blur-sm">
            <nav className="px-2 py-4 space-y-1">
              <Link 
                to="/about" 
                className={`block px-4 py-3 rounded-lg text-sm font-semibold tracking-wide transition-all duration-200 ${
                  isActive('/about')
                    ? 'text-gray-900 bg-gray-100 border-l-4 border-gray-400'
                    : 'text-gray-800 hover:text-gray-900 hover:bg-gray-50'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
              <Link 
                to="/solution" 
                className={`block px-4 py-3 rounded-lg text-sm font-semibold tracking-wide transition-all duration-200 ${
                  isActive('/solution')
                    ? 'text-gray-900 bg-gray-100 border-l-4 border-gray-400'
                    : 'text-gray-800 hover:text-gray-900 hover:bg-gray-50'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Solutions
              </Link>
              
              <div className="pt-4 border-t border-gray-200/50 mt-4 space-y-3">
                <Link 
                  to="/login"
                  onClick={() => setIsMenuOpen(false)}
                  className="block w-full text-purple-600 hover:text-purple-700 px-4 py-3 text-sm font-medium transition-all duration-200 border border-purple-200 rounded-lg hover:bg-purple-50 text-center"
                >
                  Alpha Login
                </Link>
                <button 
                  onClick={() => {
                    setIsMenuOpen(false);
                    openRequestModal();
                  }}
                  className="block w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 text-center"
                >
                  Get Started
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
